import React, { useState, useEffect, useRef } from "react";
import {
  Modal,
  Button,
  Row,
  Col,
  Divider,
  Select,
  Input,
  DatePicker,
  InputNumber,
  Form,
  message,
  Table,
  Tooltip,
} from "antd";
import { MinusCircleOutlined, PlusCircleOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { AdherentsService } from "../../Services/AdherentsService";
import { ParticipantsIpmService } from "../../Services/ParticipantsIpmService";
import { PrestationsService } from "../../Services/PrestationsService";
import { useParams } from "react-router-dom";
import dayjs from "dayjs"
import Draggable from "react-draggable";
const documentTypes = [
  { typedoc: 'BPI', name: 'Bon de Pharmacie' },
  { typedoc: 'LGI', name: 'Lettre de garantie' },
  { typedoc: 'LHI', name: 'LG Hospitalisation' },
  { typedoc: 'BCI', name: 'Bon Optique' },
  { typedoc: 'TIC', name: 'Ticket Remboursement' },
  { typedoc: 'AV', name: "Bon d'avoir" },
];
const { Option } = Select;

const DraggableModal = ({ children, ...props }) => {
  const [disabled, setDisabled] = useState(true);
  const draggleRef = useRef(null);

  return (
    <Modal
      {...props}
      modalRender={(modal) => (
        <Draggable
          disabled={disabled}
          bounds={draggleRef.current ? draggleRef.current : undefined}
          handle=".ant-modal-title"
        >
          <div ref={draggleRef}>{modal}</div>
        </Draggable>
      )}
      title={
        <div
          className="ant-modal-title"
          style={{ width: '100%', cursor: 'move' }}
          onMouseOver={() => setDisabled(false)}
          onMouseOut={() => setDisabled(true)}
        >
          {props.title}
        </div>
      }
    >
      {children}
    </Modal>
  );
};

const ModalBM = ({ isOpen, onClose, onSuccess, codespe, numfourn, editingRecord, isEditing }) => {
  const numenreg = useParams().numenreg;
  const [adherents, setAdherents] = useState([]);
  const [participants, setParticipants] = useState([]);
  const [beneficiaires, setBeneficiaires] = useState([]);
  const [tauxPCData, setTauxpcData] = useState([]);
  const [selectedTypeDoc, setSelectedTypeDoc] = useState('');
  const [isAmountDisabled, setIsAmountDisabled] = useState(false);
  const [showActButton, setShowActButton] = useState(false);
  const [actes, setActes] = useState([]);
  const [showInputs, setShowInputs] = useState(false);
  const [tableRows, setTableRows] = useState([]);
  const [payloadActes, setPayloadActes] = useState([]);
  const [isNumDocChecked, setIsNumDocChecked] = useState(false);
  const [prestationsData, setPrestationsData] = useState(null);

  const prestationsService = new PrestationsService();
  const adherentsService = new AdherentsService();
  const participantsIpmService = new ParticipantsIpmService();
  const [form] = Form.useForm();

  useEffect(() => {
    if (isOpen) {
      fetchAdherents();
      fetchPrestation();
      if (isEditing && editingRecord) {

        form.setFieldsValue({
          ...editingRecord,
          datedoc: editingRecord.datedoc ? dayjs(editingRecord.datedoc) : null,

        });
        setSelectedTypeDoc(editingRecord.typedoc);
        fetchParticipants(editingRecord.codesoc);
        fetchBeneficiaires(editingRecord.matripart);

        if (editingRecord.typedoc === 'BCI') {
          setShowInputs(true);
          setTableRows(editingRecord.actes || []); // suppose que `actes` est un tableau des lignes de la table
        }
      } else {
        form.resetFields();
        setSelectedTypeDoc('');
        setShowInputs(false);
        setTableRows([]);
      }

    }
  }, [isOpen, isEditing, editingRecord]);

  const fetchAdherents = async () => {
    try {
      const adherentsData = await adherentsService.getAllAdherents();
      setAdherents(adherentsData);
    } catch (error) {
      console.error("Erreur lors de la récupération des adhérents :", error);
    }
  };

  const fetchPrestation = async () => {
    try {
      const prestations = await prestationsService.getAllPrestation();
      setPrestationsData(prestations);
    } catch (error) {
      console.error("Erreur lors de la récupération des adhérents :", error);
    }
  };

  const fetchParticipants = async (codesoc) => {
    try {
      const participantsData = await participantsIpmService.getOneListtParticipant(codesoc);
      setParticipants(participantsData);
    } catch (error) {
      console.error("Erreur lors de la récupération des participants :", error);
      message.error("Erreur lors de la récupération des participants.");
    }
  };

  const fetchBeneficiaires = async (matripart) => {
    try {
      const benefData = await participantsIpmService.getBenefParticipant(matripart);
      setBeneficiaires(benefData);
    } catch (error) {
      console.error("Erreur lors de la récupération des bénéficiaires :", error);
      message.error("Erreur lors de la récupération des bénéficiaires.");
    }
  };
  /* const handleTypeDocChange = async (value) => {
    setSelectedTypeDoc(value);
    if (['TIC', 'AV'].includes(value)) {
      form.setFieldsValue({ numdoc: '1' });
      setIsAmountDisabled(false);
      setShowActButton(false);
    } else if (value === 'BCI') {
      try {
        const data = await prestationsService.getLignePrestation04();
        setIsAmountDisabled(true);
        setShowActButton(true);
      } catch (error) {
        console.error('Erreur lors de la récupération des données pour BO:', error);
      }
    } else {
      setIsAmountDisabled(false);
      setShowActButton(false);
    }
  }; */
  const handleTypeDocChange = async (value) => {
    setSelectedTypeDoc(value);
    if (['TIC', 'AV'].includes(value)) {
      form.setFieldsValue({ numdoc: '1' });
      setIsAmountDisabled(false);
      setShowActButton(false);
    } else {
      // Réinitialiser ou vider le champ numdoc pour les autres options
      form.setFieldsValue({ numdoc: '' });
      setIsAmountDisabled(false);
      setShowActButton(false);

      if (value === 'BCI') {
        try {
          const data = await prestationsService.getLignePrestation04();
          setIsAmountDisabled(true);
          setShowActButton(true);
        } catch (error) {
          console.error('Erreur lors de la récupération des données pour BO:', error);
        }
      }
    }
  };

  const handleNumDocBlur = async () => {
    if (isNumDocChecked) return;

    try {
      const numdoc = form.getFieldValue('numdoc');
      const existingDoc = await prestationsService.Verify(numdoc);
      if (existingDoc) {
        Modal.warning({
          title: 'Avertissement',
          content: `Ce bon existe déjà. Référence: Code fourn: ${existingDoc.codefourn}, Num Fact: ${existingDoc.numfact}`,
          onOk: () => { },
        });
      }
      setIsNumDocChecked(true);
    } catch (error) {
      console.error('Erreur lors de la vérification du numéro de document:', error);
    }
  };



  const handleSocieteChange = async (value) => {
    try {
      const participantsData = await participantsIpmService.getOneListtParticipant(value);
      setParticipants(participantsData);
    } catch (error) {
      console.error("Erreur lors de la récupération des données du participant :", error);
      message.error("Erreur lors de la récupération des participants.");
    }
  };

  const handleMatPartChange = async (value) => {
    console.log(value);
    try {
      // Récupération des bénéficiaires du participant sélectionné
      const benefData = await participantsIpmService.getBenefParticipant(value);
      // Définir les données des bénéficiaires récupérées dans l'état
      setBeneficiaires(benefData);

      // Réinitialiser les champs du formulaire pour le Type et le Bénéficiaire
      form.setFieldsValue({
        codetype: undefined,
        matribenef: undefined,
      });
    } catch (error) {
      console.error("Erreur lors de la récupération des données du participant :", error);
      // Gérez l'erreur si nécessaire
    }
  };

  useEffect(() => {
    const fetchActes = async () => {
      const data = await prestationsService.getLignePrestation04();
      setActes(data);
    };

    fetchActes();
  }, []);

  const documentLabels = {
    BPI: 'N° Bon de Pharmacie',
    LGI: 'N° Lettre de garantie',
    LHI: 'N° LG Hospitalisation',
    BCI: 'N° Bon Optique',
    TIC: 'N° Ticket Remboursement',
    AV: "N° Bon d'avoir",
  };

  useEffect(() => {
    form.setFieldsValue({
      qte: 1, // Quantité par défaut
      montant_remise: 0, // montant_remise par défaut
    });
  }, [form]);

  const handleAddClick = async () => {
    const codeacte = form.getFieldValue('libacte'); // Le code de l'acte sélectionné
    const qte = form.getFieldValue('qte') || 1;
    const montant_remise = form.getFieldValue('montant_remise') || 0;
    const tarif = form.getFieldValue('tarif');
    const matribenef = form.getFieldValue('matribenef');
    const matripart = form.getFieldValue('matripart');
    const codesoc = form.getFieldValue('codesoc');
    const categprof = form.getFieldValue('categprof')
    // Trouvez l'acte sélectionné pour obtenir le libacte et le tarif
    const selectedActe = actes.find(acte => acte.codeacte === codeacte);
    if (!selectedActe) {
      message.error('Acte sélectionné non trouvé.');
      return;
    }

    if (tableRows.find(row => row.key === selectedActe.codeacte)) {
      message.error('Cet acte a déjà été ajouté.');
      return;
    }

    const montant = qte * tarif; // Calcul du montant

    const newRow = {
      key: selectedActe.codeacte,
      number: tableRows.length + 1,
      libacte: selectedActe.libacte,
      qte,
      tarif,
      montant: montant
    };

    // Ajout de la nouvelle ligne à tableRows pour mise à jour de la table
    setTableRows(currentRows => {
      const updatedRows = [...currentRows, newRow];
      const montantTotal = updatedRows.reduce((acc, curr) => acc + curr.montant, 0);
      form.setFieldsValue({ montdoc: montantTotal }); // Mise à jour du montant total dans le formulaire
      return updatedRows;
    });

    const newPayloadActe = {
      Prestation: selectedActe,
      ajustmt: 0,
      fexclus: 0,
      codeprest: selectedActe.codeprest,
      freel: tarif,
      intitule: "",
      numdoc: "",
      numligne: null,
      qpassur: 0,
      qpmut: 0,
      qte,
      tarif: tarif,
      ticket: 0,
    };

    // Mise à jour immédiate de payloadActes pour construire le payload
    setPayloadActes(currentPayloadActes => [...currentPayloadActes, newPayloadActe]);

    // Construisez votre payload ici, en utilisant les nouvelles valeurs
    const payload = {
      actes: [...payloadActes, newPayloadActe], // Cette ligne pourrait nécessiter un ajustement basé sur la synchronisation de l'état
      codefourn: numfourn,
      categprof,
      codepresc: "99999",
      codesoc,
      codeprest: selectedActe.codeprest,
      matribenef,
      matripart,
      montant_remise: montant_remise,
      montdoc: montant,
      natprest: "04",
      qpmut: 0,
      remb_integral: false,
      ticket: 0,
      typebenef: "1",
    };

    // Déplacez l'appel de addPrestation ici
    try {
      const addedPrestation = await prestationsService.addTauxPC(payload);
      setTauxpcData(addedPrestation)
      message.success('Prestation ajoutée avec succès!');
      form.setFieldsValue({

        qte: 1,
        libacte: undefined,
        tarif: 0,
      });
    } catch (error) {
      message.error("Erreur lors de l'ajout de la prestation.");
    }
  };

  const supprimerLigne = (key) => {
    // Suppression de la ligne sélectionnée
    const nouvellesLignes = tableRows.filter(ligne => ligne.key !== key);
    setTableRows(nouvellesLignes);

    // Recalcul du montant total après la suppression de la ligne
    const montantTotal = nouvellesLignes.reduce((acc, curr) => acc + curr.montant, 0);
    form.setFieldsValue({ montdoc: montantTotal }); // Mise à jour du montant total dans le formulaire

    // Optionnellement, réinitialiser/remettre à jour d'autres champs si nécessaire
    form.setFieldsValue({
      montant_remise: 0, // Par exemple, réinitialiser la montant_remise si vous le souhaitez
    });

    // Mise à jour de payloadActes si nécessaire
    // Si vos actes sont directement liés aux lignes de la table, vous devez les ajuster en conséquence
    const updatedPayloadActes = nouvellesLignes.map(ligne => {
      // Trouvez et retournez l'objet de payload correspondant à la ligne
      // Ceci est un exemple basique; ajustez selon votre structure de données spécifique
      return payloadActes.find(p => p.Prestation.codeacte === ligne.key);
    });
    setPayloadActes(updatedPayloadActes);
  };

  const handleSubmit = () => {
    form
      .validateFields()
      .then(async (values) => {
        try {
          const numdoc = form.getFieldValue('numdoc');
          const userId = localStorage.getItem('login');
          // Vérifiez si le document existe déjà uniquement si vous n'êtes pas en mode édition
          if (!isEditing) {
            const existingDoc = await prestationsService.Verify(numdoc);
            if (existingDoc) {
              Modal.warning({
                title: 'Avertissement',
                content: `Ce bon existe déjà.`,
                onOk: () => { },
              });
              return; // Arrêtez la soumission si le bon existe déjà
            }
          }


          // Ici, ajustons les données du formulaire selon les attentes de votre API
          const docData = {
            // Structurez `docData` en fonction de ce que votre API attend
            ...values,
            codefourn: numfourn,
            codepresc: "99999",
            codeprest: values.natprest,
            qpmut: tauxPCData.qpmut,
            ticket: tauxPCData.ticket,
            natprest: values.natprest,
            actes: payloadActes,
            exonerer: "false",
            naturedoc: "Manuel",
            numdoc: numdoc,
            remb_integral: false,
            typebenef: values.matribenef ? values.matribenef.split('-').pop().trim().charAt(0) : undefined,
            numfact: numenreg,
            user_id: userId, // Utilisateur connecté
          };

          let response;
          if (isEditing) {
            // Appel à l'API pour la modification
            response = await prestationsService.updateLigneDocMedoc(docData);
            message.success("Bon manuel modifié avec succès!");
          } else {
            // Appel à l'API pour la création
            response = await prestationsService.AddLigneDocMedoc(docData);
            message.success("Bon manuel créé avec succès!");
          }

          if (onSuccess) onSuccess(); // Appel du callback
          // Reset du formulaire et fermeture du modal ici, si nécessaire
          form.resetFields();
          onClose(); // Supposant que `onClose` ferme le modal

        } catch (error) {
          // Gestion des erreurs de l'appel API
          console.error('Erreur lors de la soumission du bon manuel:', error);
          message.error(isEditing ? "La modification du bon manuel a échoué." : "La création du bon manuel a échoué.");
        }
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
        message.error("La validation du formulaire a échoué.");
      });
  };

  // Colonnes de la table
  const colonnes = [
    { title: 'N°', dataIndex: 'number', key: 'number', align: 'center' },
    { title: 'Nom', dataIndex: 'libacte', key: 'libacte' },
    { title: 'Qt', dataIndex: 'qte', key: 'qte', align: 'center' },
    { title: 'Tarif', dataIndex: 'tarif', key: 'tarif', align: 'right' },
    { title: 'Montant', dataIndex: 'montant', key: 'montant', align: 'right' },
    {
      title: (
        <div
          style={{
            backgroundColor: "#010f1c",
            color: "white",
            padding: "1px",
          }}
        ></div>
      ),
      key: 'action',
      align: 'center',
      render: (_, record) => (
        <Button icon={<MinusCircleOutlined />} onClick={() => supprimerLigne(record.key)} />
      ),
    },
  ];

  const handleDeleteAllRows = () => {
    setTableRows([]);
    form.setFieldsValue({ montdoc: 0 });
    setPayloadActes([]);
  };


  return (
    <DraggableModal
      width={1200}
      title={isEditing ? `Modifier Bon Manuel N° ${editingRecord.numdoc}` : `Créer Bon Manuel N° ${numfourn}`}
      open={isOpen}
      onCancel={() => {
        form.resetFields();
        form.setFieldsValue({
          montant_remise: 0,
          qte: 1,
          libacte: undefined,
          tarif: 0,
        });
        onClose();
        setShowActButton(false);
        setShowInputs(false);
      }}
      maskClosable={false}
      footer={[
        <Button key="back" onClick={() => {
          form.resetFields();
          form.setFieldsValue({
            montant_remise: 0,
            qte: 1,
            libacte: undefined,
            tarif: 0,
          });
          onClose();
          setShowActButton(false);
          setShowInputs(false);
        }} >
          Annuler
        </Button>,
        <Button key="submit" className="Buttonvalid" onClick={handleSubmit}>
          {isEditing ? 'Modifier' : 'Créer'}
        </Button>,
      ]}
    >
      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <Row gutter={16}>
          <Col span={12}>
            <Divider orientation="left">
              Information Fournisseur
            </Divider>
            <Row gutter={16}>
              <Col span={14}>
                <Form.Item
                  label="Type de document"
                  name="typedoc"
                  rules={[
                    {
                      required: true,
                      message: "Veuillez sélectionner un type de document!",
                    },
                  ]}
                >
                  <Select
                    placeholder="Sélectionnez un type"
                    style={{ width: "100%" }}
                    onChange={handleTypeDocChange}
                    showSearch
                    filterOption={(input, option) =>
                      option.children.toLowerCase().includes(input.toLowerCase())
                    }
                  >
                    {documentTypes.map(doc => (
                      <Option key={doc.typedoc} value={doc.typedoc}>
                        {`${doc.name}`}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={10}>
                {/*  <Form.Item
                  label={documentLabels[selectedTypeDoc] || "N°"}
                  name="numdoc"
                  rules={[
                    { required: true, message: "Veuillez entrer un numéro!" },
                  ]}
                >
                  <Input style={{ width: "100%" }} onBlur={handleNumDocBlur} />
                </Form.Item> */}
                {selectedTypeDoc !== 'TIC' && (
                  <Form.Item
                    label={documentLabels[selectedTypeDoc] || "N°"}
                    name="numdoc"
                    rules={[
                      { required: true, message: "Veuillez entrer un numéro!" },
                    ]}
                  >
                    <Input style={{ width: "100%" }} onBlur={handleNumDocBlur} />
                  </Form.Item>
                )}

              </Col>
            </Row>

            <Divider orientation="left">
              Participant
            </Divider>
            <Form.Item
              label="Société"
              name="codesoc"
              rules={[{ required: true, message: "Ce champ est obligatoire!" }]}
            >
              <Select
                style={{ width: "100%" }}
                defaultValue={"--Selectionner--"}
                onChange={handleSocieteChange}
                showSearch
                filterOption={(input, option) =>
                  option.children.toLowerCase().includes(input.toLowerCase())
                }
              >
                {adherents.map((adherent) => (
                  <Option key={adherent.codeadht} value={adherent.codeadht}>
                    {`${adherent.codeadht} - ${adherent.intitule}`}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              label="Matricule Partcipant"
              name="matripart"
              rules={[{ required: true, message: "Ce champ est obligatoire!" }]}
            >
              <Select
                defaultValue={"--Selectionner--"}
                style={{ width: "100%" }}
                disabled={!participants} // Grise si participantsData est null
                onChange={handleMatPartChange}
                showSearch
                filterOption={(input, option) =>
                  option.children.toLowerCase().includes(input.toLowerCase())
                }
              >
                {participants &&
                  participants.map((participant) => (
                    <Option
                      key={participant.numcont}
                      value={participant.numcont}
                    >
                      {`${participant.matricule} - ${participant.part}`}
                    </Option>
                  ))}
              </Select>
            </Form.Item>

            <Divider orientation="left">
              Bénéficiaire
            </Divider>
            <Form.Item
              label="Bénéficiaire"
              name="matribenef"
              rules={[{ required: true, message: "Ce champ est obligatoire!" }]}
              showSearch
              filterOption={(input, option) =>
                option.children.toLowerCase().includes(input.toLowerCase())
              }
            >
              <Select>
                {beneficiaires.map((beneficiaire) => (
                  <Option
                    key={beneficiaire.matribenef}
                    value={beneficiaire.matribenef}
                  >
                    {`${beneficiaire.matribenef} - ${beneficiaire.prenoms ? beneficiaire.prenoms + ' ' : ''}${beneficiaire.nom ? beneficiaire.nom : ''}`}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Divider />
            <div style={{ padding: "4px" }}> </div>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item label="Date" name="datedoc" rules={[
                  { required: true, message: "Veuillez entrer une date!" },
                ]}>
                  <DatePicker disabledDate={(current) =>
                    current && current > dayjs().endOf("day")
                  } style={{ width: "100%" }} format="DD/MM/YYYY" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Montant" name="montdoc" rules={[
                  { required: true, message: "Veuillez entrer un montant!" },
                ]} >
                  <InputNumber style={{ width: "100%" }} disabled={isAmountDisabled} />
                </Form.Item>
              </Col>
              <Form.Item
                name="natprest"
                label="Nature prestation"
                rules={[
                  {
                    required: true,
                    message: "Veuillez sélectionner une option",
                  },
                ]}
              >
                <Select style={{ width: 350 }}
                  showSearch
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                >
                  {prestationsData &&
                    prestationsData.map((prestation) => (
                      <Option
                        key={prestation.codeprest}
                        value={prestation.codeprest}
                      >
                        {`${prestation.codeprest} - ${prestation.intitule}`}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
              {!showInputs && showActButton && (
                <Button type="primary" className="Buttonvalid"
                  // disabled={!form.getFieldValue("matribenef")}
                  onClick={() => setShowInputs(true)}>
                  Saisir les actes
                </Button>
              )}
              {showInputs && (
                <>
                  <Row>
                    <Col>
                      <Form.Item name="montant_remise" label="Remise" initialValue={0}>
                        <InputNumber placeholder="Remise" style={{ width: "100%" }} />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row gutter={16}>
                    <Col >
                      <Form.Item name="libacte">
                        <Select placeholder="Rechercher Acte" style={{ width: 200 }}>
                          {actes.map(acte => (
                            <Select.Option key={acte.codeacte} value={acte.codeacte}>{acte.libacte}</Select.Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>

                    <Col >
                      <Form.Item name="qte" initialValue={1}>
                        <InputNumber
                          placeholder="Qté"
                          min={1}

                        />
                      </Form.Item>
                    </Col>
                    <Col >
                      <Form.Item name="tarif" >
                        <InputNumber
                          placeholder="Tarif"
                          style={{ width: 150 }}
                        />
                      </Form.Item>
                    </Col>
                    <Col>
                      <Button icon={<PlusCircleOutlined />} onClick={handleAddClick} className="buttonImport" />
                    </Col>
                    <Col>
                      <Button icon={<DeleteOutlined />} onClick={handleDeleteAllRows} className="buttonClose" />
                    </Col>
                  </Row>

                  <Table
                    columns={colonnes}
                    dataSource={tableRows}
                    bordered
                    scroll={{
                      x: true,
                    }}
                    style={{ cursor: "pointer", whiteSpace: "nowrap", width: "100%" }}
                    className="custom-header-table"
                    showSorterTooltip={false}
                  />
                </>
              )}
            </Row>
          </Col>
        </Row>
      </Form>
    </DraggableModal>
  );
};

export default ModalBM;
